module.exports = __webpack_public_path__ + "media/images/checkmark-62924513dbe81c6b83529fa5198419de.svg";